const TEAM = [
  {
    id: "daryos",
    name: "Daryos Baban",
    role: "Founder & Executive Director",
    image: "https://customer-assets.emergentagent.com/job_global-youth/artifacts/2bf5s0km_IMG_7253.jpeg",
    featured: true,
  },
  {
    id: "shakar",
    name: "Shakar Jihad",
    role: "Co-Founder & Media Director",
    image: "https://customer-assets.emergentagent.com/job_global-youth/artifacts/3gme6qss_bc2b1787-d9c7-49b6-83a3-88f1bcd1bec8.jpeg",
    featured: false,
  },
  {
    id: "ayad",
    name: "Ayad Sameer",
    role: "Co-Founder & Logistics Director",
    image: "https://customer-assets.emergentagent.com/job_global-youth/artifacts/gxw2x0ar_b9d8a1e7-51d9-492f-b3d7-0ad4a5399b25.jpeg",
    featured: false,
  },
  {
    id: "shadan",
    name: "Shadan Othman",
    role: "Executive Council",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_7e4e61dd-6912-4af3-ac17-762c1ac12aa9/artifacts/3b7n4ech_WhatsApp%20Image%202026-08-25%20at%2012.46.10.jpeg",
    featured: false,
  },
  {
    id: "dastan",
    name: "Dastan Jada Namiq",
    role: "Executive Council",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_7e4e61dd-6912-4af3-ac17-762c1ac12aa9/artifacts/jk8ymgi3_for%20passport.jpg%20%281%29.jpeg",
    featured: false,
  },
];

export default function TeamPage() {
  const founder = TEAM.find(m => m.featured);
  const coFounders = TEAM.filter(m => !m.featured);

  return (
    <div className="min-h-[80vh] bg-paper" data-testid="team-page">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-24">
        
        {/* Header */}
        <div className="mb-16">
          <p className="text-[10px] tracking-[0.3em] uppercase text-muted mb-3">
            Leadership
          </p>
          <h1 className="font-serif text-4xl lg:text-5xl text-ink">
            Our Team
          </h1>
          <p className="text-muted mt-4 max-w-xl">
            The leadership team behind Global Youth Platform, dedicated to empowering 
            the next generation of global leaders.
          </p>
        </div>

        {/* Founder - Featured */}
        {founder && (
          <div 
            className="bg-white border border-black/10 mb-12"
            data-testid={`team-member-${founder.id}`}
          >
            <div className="grid md:grid-cols-2">
              {/* Image */}
              <div className="relative h-[400px] md:h-[500px] overflow-hidden">
                <img 
                  src={founder.image}
                  alt={founder.name}
                  className="absolute inset-0 w-full h-full object-cover object-top img-editorial"
                />
              </div>

              {/* Content */}
              <div className="p-8 lg:p-12 flex flex-col justify-center">
                <p className="text-[10px] tracking-[0.3em] uppercase text-crimson mb-4">
                  Founder
                </p>
                <h2 className="font-serif text-3xl lg:text-4xl text-ink mb-2">
                  {founder.name}
                </h2>
                <p className="text-lg text-muted mb-6">
                  {founder.role}
                </p>
                <div className="border-t border-black/10 pt-6">
                  <p className="text-muted leading-relaxed">
                    Leading the vision and strategic direction of Global Youth Platform, 
                    committed to creating opportunities for young leaders worldwide to 
                    engage in international diplomacy and leadership development.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Leadership Team Grid — 3 columns fits perfectly */}
        <div>
          <div className="flex items-end justify-between mb-6">
            <p className="text-[10px] tracking-[0.3em] uppercase text-muted">
              Leadership Team
            </p>
            <span className="hidden md:block h-px flex-1 mx-6 bg-black/10" />
            <p className="text-[10px] tracking-[0.2em] uppercase text-muted">
              {coFounders.length} Members
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-black/10">
            {coFounders.map((member) => (
              <div
                key={member.id}
                className="bg-white group transition-editorial hover:bg-paper"
                data-testid={`team-member-${member.id}`}
              >
                {/* Image */}
                <div className="relative h-[380px] overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="absolute inset-0 w-full h-full object-cover object-center img-editorial transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>

                {/* Content */}
                <div className="p-6 lg:p-8 border-t border-black/10">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="h-px w-6 bg-crimson" />
                    <p className="text-[10px] tracking-[0.25em] uppercase text-crimson">
                      {member.role.includes("Executive") ? "Executive Council" : "Co-Founder"}
                    </p>
                  </div>
                  <h3 className="font-serif text-2xl text-ink mb-1 leading-tight">
                    {member.name}
                  </h3>
                  <p className="text-sm text-muted tracking-wide">
                    {member.role}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Closing statement */}
        <div className="mt-20 pt-12 border-t border-black/10 max-w-2xl">
          <p className="text-[10px] tracking-[0.3em] uppercase text-muted mb-3">
            Governance
          </p>
          <p className="font-serif text-xl lg:text-2xl text-ink leading-snug">
            A leadership formed by young diplomats and international operators,
            united by a single mission — to convene the next generation at the
            world&apos;s most consequential venues.
          </p>
        </div>

      </div>
    </div>
  );
}
